<template>
  <el-container class="app-main">
    <el-row class="book-main">
      <el-col :span="20">
        <el-main>
          <div ref="scrollItem" class="component-info" v-for="(item, index) in myData" :key="index + '-cmp'">
            <el-card>
              <div slot="header" class="clearfix">
                <span>{{item.name}}</span>
              </div>

              <el-row :gutter="10">
                <el-col :span="6" v-for="(element, index) in item.arrayList" :key="index">
                  <div class="book-grid">
                    <div class="book-name">
                      <img class="book-icon" :alt="element.resoName" type="image" :src="element.resoIcon" :onerror="defaultImg" />
                      {{element.resoName}}
                    </div>
                    <div class="book-content">
                      <div class="book-desc" :title="element.resoDesc">{{element.resoDesc}}</div>
                    </div>
                    <a v-if="!openEdit" class="book-link" :title="element.resoDesc" :href="element.resoPath" target="_blank"></a>
                  </div>
                </el-col>

              </el-row>
            </el-card>
          </div>
          </div>
        </el-main>
      </el-col>

      <el-col :span="4" style="position: sticky;top: 80px;">
        <el-aside width="180px" class="slider-menu">
          <div class="slider-menu-item" v-for="(item, index) in myData" :key='index' :style="item.style || {}" :class="{'slider-menu-item-active': current === index}"
            @click="scrollToView(index)">
            <span>{{item.name}}</span>
          </div>
        </el-aside>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
  import {
    fetchBookData
  } from '@/api/index';
  export default {
    name: "Book",
    components: {},
    props: {
      data: {
        type: [String, Number, Boolean, Object, Array],
        default: () => [{
          name: '常用工具',
          style: {},
          component: "",
          arrayList: [],
          disabled: true
        }]
      }
    },
    data() {
      return {
        defaultImg: 'onerror=null;this.src="' + require('@/assets/svg/icon.svg') + '"', // 空白占位图
        openEdit: false, // 默认不可编辑
        // myData: [],
        current: 0
      }
    },
    methods: {
      init() {
        if (this.$store.getters.getBooks.length > 0) {
          console.info("$store.getters.getBooks", this.$store.getters.getBooks);
          return;
        };

        fetchBookData({
            params: {
              "dictType": "book_resource_type"
            }
          }) // axios 请求在这里
          .then((res) => {
            let result = res.data;
            if (result.success === true) {
              console.log("result:", result);
              this.$store.commit('getBook', result.data.result);
            };
          }).catch((error) => {
            console.log("error:", error);
          });
      },
      scrollToView(index) {
        let data = this.getScrollItems()
        if (index >= 0 && index < data.length) {
          let item = data[index] || {}
          const scrollTop = this.getScroll(window, true)
          const elOffset = this.getOffset(item)
          let top = elOffset.top - this.getStartTop() - 60;
          window.scrollTo({
            top: top < 0 ? 0 : top,
            behavior: 'smooth'
          })
        }
      },
      handleScroll(e) {
        let data = this.getScrollItems()
        const scrollTop = this.getScroll(window, true)
        let maxTop = -99999
        data.forEach((target, index) => {
          const elOffset = this.getOffset(target)
          let realTop = elOffset.top - this.getStartTop() - scrollTop - 60
          if (realTop <= 0 && maxTop <= realTop) {
            maxTop = realTop
            this.current = index;
          }
        })
      },
      getStartTop() {
        if (this.$refs.sliderMenu) {
          return this.$refs.sliderMenu.offsetTop || 0
        }
        return 0
      },
      getScrollItems() {
        let refs = []
        if (this.$refs.scrollItem && this.$refs.scrollItem.style) {
          refs.push(this.$refs.scrollItem)
        } else if (this.$refs.scrollItem && this.$refs.scrollItem.length) {
          refs = this.$refs.scrollItem
        }
        return refs
      },
      getScroll(target, top) {
        const prop = top ? 'pageYOffset' : 'pageXOffset'
        const method = top ? 'scrollTop' : 'scrollLeft'
        let ret = target[prop]
        if (typeof ret !== 'number') {
          ret = window.document.documentElement[method]
        }
        return ret
      },
      getOffset(element) {
        const rect = element.getBoundingClientRect()
        const scrollTop = this.getScroll(window, true)
        const scrollLeft = this.getScroll(window)

        const docEl = window.document.body
        const clientTop = docEl.clientTop || 0
        const clientLeft = docEl.clientLeft || 0
        let height = rect.bottom - rect.top
        if (height === 0 && element.parentNode) {
          let parentRect = element.parentNode.getBoundingClientRect()
          height = parentRect ? parentRect.height || 0 : 0
        }
        return {
          top: rect.top + scrollTop - clientTop,
          left: rect.left + scrollLeft - clientLeft,
          height: height,
          width: rect.right - rect.left
        }
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    },
    watch: {
      tempMyData: function(newName, oldName) {
        console.info("newName:", newName);
        console.info("oldName:", oldName);
        console.info("\n");
      }
    },
    created() {
      this.init()
    },
    computed: {
      myData() {
        return this.$store.getters.getBooks;
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, false);
      window.addEventListener('resize', this.handleScroll, false);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll, false);
      window.removeEventListener('resize', this.handleScroll, false);
    }
  }
</script>

<style scoped lang="less">
  .el-header,
  .el-footer {}

  .el-aside {
    max-height: calc(100vh - 100px);
    padding-left: 20px;
  }

  .el-main {
    padding: 0;
  }

  .app-main {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;

    .book-grid {
      position: relative;
      padding: 10px 10px;
      margin: 4px 0;
      border-radius: 4px;
      cursor: pointer;

      .book-name {
        height: 34px;
        line-height: 34px;
        font-weight: bold;
        font-size: 14px;
        color: #444;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
      }

      .book-icon {
        width: 34px;
        height: 34px;
        min-width: 34px;
        min-height: 34px;
        border-radius: 50px;
        border: 1px solid transparent;
        margin-right: 12px;
      }

      .book-content {
        position: relative;
      }

      .book-desc {
        font-size: 12px;
        color: #585858;
        text-align: justify;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        min-height: 32px;
        margin-top: 5px;
        line-height: 16px;
      }

      .book-link {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }

    .book-grid:hover {
      background-color: #DBDBDB;
      transform: translateY(-6px);
      transition: all 0.3s ease-in-out;

      .book-name {
        color: #409EFF;
      }

      .book-content {
        .book-icon {}

        .book-desc {
          color: #409EFF;
        }
      }
    }

    .book-main {
      width: 100%;
      height: auto;
      min-height: 100vh;

      .el-card {
        margin-bottom: 20px;
      }

      .slider-menu {
        // position: fixed;
        // overflow: auto;
        // color: #000;
        // height: auto;
        // top: auto;
        // z-index: 2;
      }

      .slider-menu-item {
        position: relative;
        display: block;
        border-left: 2px solid #e8eaed;
        padding: 10px 20px;
        margin: auto;
        line-height: 24px;
        color: inherit;
        cursor: pointer;
      }

      .slider-menu-item-active,
      .slider-menu-item:hover {
        color: rgb(64, 158, 255);
      }

      .slider-menu-item-active {
        border-left: 2px solid rgb(64, 158, 255);
      }

      .el-icon-class {
        position: absolute;
        right: 0;
        top: 0;
        color: rgb(64, 158, 255);
        cursor: pointer;
      }

      .el-icon-remove.el-icon-class {
        color: red;
      }

      .book-card {
        position: relative;
        margin: 10px;
        height: 100px;
        width: 100px;
        text-align: center;
        border-radius: 10px;
        font-size: 14px;
        border-color: transparent;
        background-color: transparent;
        background: rgba(170, 170, 170, .4);
      }

      .book-card:hover {
        color: rgb(64, 158, 255);
        background: rgba(170, 170, 170, .4);
      }

      .book-card .img {
        width: 40px;
        height: 40px;
        margin: 15px auto 0;
        border-radius: 10px;
      }

      .book-card .text {
        /* line-height: 1; */
        margin: 5px 8px 0;
        /*溢出隐藏*/
        overflow: hidden;
        /*以省略号...显示*/
        text-overflow: ellipsis;
        /*强制不换行*/
        white-space: nowrap;
      }

      .book-card .link {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {}
</style>



// WEBPACK FOOTER //
// src/components/Book.vue